import React from 'react';

import PropTypes from 'prop-types';

import OrderDetailsFulfillmentDisplaySection from '../../../fulfillment/section';
import ShipmentDisplayContent from '../../../fulfillment/shipment-display/content';
import ReturnFulfillmentDisplayContextProvider from './provider';

const FulfillmentDisplay = ({ returnFulfillmentId }) => {
  return (
    <OrderDetailsFulfillmentDisplaySection>
      <ReturnFulfillmentDisplayContextProvider returnFulfillmentId={returnFulfillmentId}>
        <ShipmentDisplayContent isReturn />
      </ReturnFulfillmentDisplayContextProvider>
    </OrderDetailsFulfillmentDisplaySection>
  );
};

export default FulfillmentDisplay;

FulfillmentDisplay.propTypes = {
  returnFulfillmentId: PropTypes.string.isRequired,
};
